// extracted by mini-css-extract-plugin
export default {"flex-inline":"UvpoeWG1JHjkgwa7MXrp","form":"Qhm9z3XYpRNELdzDIfc9"};